import { Demand, IDemand } from '../../demand/types/Demand';
import { DemandDataService } from '../../demand/demand-data.service';
import { PurchaseRequisitionStatus } from './PurchaseRequisitionStatus';
import { PurchaseRequisitionStatusEnum } from './PurchaseRequistionStatusEnum';
import dayjs, { Dayjs } from 'dayjs';
import { CommentDataService } from '@lib/comment';
import { ItemClassificationDataService } from '@lib/classification';
import { FileDataService } from '@lib/file';
import {
    IPurchaseRequisitionOrderResult,
    IPurchaseRequisitionResultDocument,
    IPurchaseRequisitionRfqResult,
    PurchaseRequisitionOrderResult,
    PurchaseRequisitionRfqResult,
} from './IPurchaseRequisitionResultDocument';
import { PurchaseRequisitionResult } from './PurchaseRequisitionResult';
import { I18nService } from '@lib/i18n';
import { PurchaseRequisitionDeliveryStatus, PurchaseRequisitionOrderStatus } from '@lib/util';

export interface IPurchaseRequisition {
    id: string;
    demand: IDemand;
    number: string;
    created: string;
    validUntil: string;
    status: PurchaseRequisitionStatusEnum;
    orderStatus: PurchaseRequisitionOrderStatus;
    deliveryStatus: PurchaseRequisitionDeliveryStatus;
    rfqs: IPurchaseRequisitionRfqResult[];
    orders: IPurchaseRequisitionOrderResult[];
    resultsIn: PurchaseRequisitionResult;
}

export class PurchaseRequisition {
    public readonly id: string;
    public readonly demand: Demand;
    public readonly number: string;
    public readonly status: PurchaseRequisitionStatus;
    public readonly orderStatus: PurchaseRequisitionOrderStatus;
    public readonly deliveryStatus: PurchaseRequisitionDeliveryStatus;
    public readonly orders: IPurchaseRequisitionResultDocument[];
    public readonly rfqs: IPurchaseRequisitionResultDocument[];

    public onChange?: () => void;

    private _resultsIn: PurchaseRequisitionResult;
    private readonly _announcedTimestamp: Dayjs;

    constructor(
        dto: IPurchaseRequisition,
        demandDataService: DemandDataService,
        commentDataService: CommentDataService,
        itemClassificationDataService: ItemClassificationDataService,
        fileDataService: FileDataService,
        i18n: I18nService
    ) {
        this.id = dto.id;
        this.demand = Demand.fromDto(
            dto.demand,
            demandDataService,
            commentDataService,
            itemClassificationDataService,
            fileDataService,
            i18n
        );
        this._announcedTimestamp = dayjs(dto.created);
        this.number = dto.number;
        this.status = new PurchaseRequisitionStatus(dto.status);
        this.orderStatus = dto.orderStatus;
        this.deliveryStatus = dto.deliveryStatus;
        this.rfqs = dto.rfqs.map((dto) => PurchaseRequisitionRfqResult.fromDto(dto));
        this.orders = dto.orders.map((dto) => PurchaseRequisitionOrderResult.fromDto(dto));
        this._resultsIn = dto.resultsIn;
    }

    public get announcedTimestamp(): string {
        return this._announcedTimestamp.format('DD.MM.YYYY HH:mm');
    }

    public get statusName(): string {
        return this.status.statusText;
    }

    public get statusColor(): string {
        return this.status.textColor;
    }

    get resultsIn(): PurchaseRequisitionResult {
        return this._resultsIn;
    }

    set resultsIn(value: PurchaseRequisitionResult) {
        this._resultsIn = value;
        if (this.onChange) {
            this.onChange();
        }
    }

    get resultsInOrder(): boolean {
        return this._resultsIn === PurchaseRequisitionResult.ORDER;
    }
}
